import { isItProductionServer } from '../../constant'
import { getUserInfo } from '../../helpers/Util'

let testToken = 'tt-ncau0Lv2UbU'
let productionToken = 'tt-5v9axI3HQE6'
let testSurveyName = 'Test-general-Feedback-buyer'
let productionSurveyName = 'Production-general-Feedback-buyer'

export const loadGlobalSurveyWidget = () => {
    if (document.getElementById('ss-widgets')) return
    const script = document.createElement('script')
    script.id = 'ss-widgets'
    script.async = true
    script.src = `https://nitex.surveysparrow.com/widget/${
        isItProductionServer() ? productionToken : testToken
    }`

    const customParams = {
        name: getUserInfo()?.name,
        user_email: getUserInfo()?.email,
        organization_type: getUserInfo()?.organizationType,
        user_type: getUserInfo()?.primaryUserType,
        brand_name: getUserInfo()?.brandResponse?.name,
        user_id: getUserInfo()?.id
    }

    window.SS_WIDGET_TOKEN = isItProductionServer()
        ? productionToken
        : testToken
    window.SS_ACCOUNT = 'nitex.surveysparrow.com'
    window.SS_SURVEY_NAME = isItProductionServer()
        ? productionSurveyName
        : testSurveyName
    window.SS_VARIABLES = customParams

    script.onload = () => {
        if (window.SurveySparrow) {
            window.SurveySparrow.init({
                token: isItProductionServer() ? productionToken : testToken,
                variables: customParams
            })
        }
    }
    document.body.appendChild(script)
}

export const cleanupGlobalSurveyWidget = () => {
    const widget = document.getElementById('ss-widgets')
    if (widget) {
        widget.remove()
    }
}
